import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CreateUIUserTaskInput, UIUserTaskFilterInput } from './inputs';
import { UIUserTaskResource } from './resources';
import { UIUserTaskRef } from './refs';
import { CollectionResource } from '@app/data/resources';

export default class UIUserTask {
    private basePath = '/api/ui-user-task';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Fetch list of non-completed active tasks
    get = async (filter: UIUserTaskFilterInput): Promise<CollectionResource<UIUserTaskResource, {}>> => {
        const query = qs.stringify({ ...filter });

        const { data } = await this.http.get(`${this.basePath}/pending?${query}`);

        return data;
    };

    // Create new UI user task
    create = async (input: CreateUIUserTaskInput): Promise<UIUserTaskRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);

        return data;
    };

    // Mark UI user task a complete
    complete = async (id: ID): Promise<UIUserTaskRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/complete`);

        return data;
    };
}
